import { Box, Button, Checkbox, FormControl, FormControlLabel, IconButton, Input, InputAdornment, InputLabel, TextField, Typography } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signup, signupFlagOff, loginWithGoogle, loginFlagOff } from "../../redux/actions/User";
import { useForm, Controller } from "react-hook-form";
import toast from "react-hot-toast";
import Circularbar from "../../components/circularbar/Circularbar";
import { useTranslation } from "react-i18next";
import { signInWithPopup } from "firebase/auth";
import { fbAuth, provider } from "../../firbaseConfig";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import CheckIcon from '@mui/icons-material/Check';
import AuthLayout from "./Layout";

const imNotArobotButtonStyles = {
    minWidth: "250px",
    height: "50px",
    padding: "10px",
    backgroundColor: "#F9F9F9",
    border: "1px solid #C1C1C1",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#000",
    fontSize: "15px",
    cursor: "pointer"
}

function Signup() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { auth, loging, loggedin, logFail, logBlocked, logout, isVerified, isRegistered, signupSppiner } = useSelector((state) => state.User);
  const [type, setType] = useState(true);
  const [role, setRole] = useState("user");
  const [confirmPasswordType, setConfirmPasswordType] = useState(true);
  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    reset,
    watch,
    control,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });

  useEffect(() => {
    if (isRegistered) {
      toast.success(t("views.signup.accountCreated"));
      navigate("/login");
      dispatch(signupFlagOff());
    }
  }, [isRegistered]);

  useEffect(() => {
    if (loggedin) {
      toast.success(t("views.login.loginSuccess"));
      dispatch(loginFlagOff());
      dispatch(signupFlagOff());
    }
    if (logFail) {
      toast.error(t("views.login.invalidCredentials"));
      dispatch(loginFlagOff());
      dispatch(signupFlagOff());
    }
    if (logBlocked) {
      toast.error(t("views.login.userBlocked"));
      dispatch(loginFlagOff());
      dispatch(signupFlagOff());
    }
    if (!isVerified) {
      toast.error(t("views.login.verificationRequired"));
      dispatch(loginFlagOff());
      dispatch(signupFlagOff());
    }
  }, [logFail, logBlocked, loggedin, isVerified]);

  const onGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(fbAuth, provider);
      if (result) {
        dispatch(loginWithGoogle(result));
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (auth) {
    return navigate("/");
  }

  const onSubmit = async (data) => {
    try {
      await dispatch(
        signup({
          fullname: data.fullname,
          email: data.email,
          password: data.password,
          confirmPassword: data.confirmPassword,
          role: role,
          captcha: data.captcha
        })
      );
      reset({
        fullname: "",
        email: "",
        password: "",
        confirmPassword: "",
        captcha: ""
      });
    } catch (error) {
      if (error?.response?.data?.message) {
        dispatch(signupFlagOff());
        if(error.response.data.message == 'reCaptchaErr'){
          toast.error(t("views.signup.recaptchaFailed"))
        }else if(error.response.data.message == 'noReCaptcha'){
          toast.error(t("views.signup.recaptchaErr"))
        }else{
          toast.error(error.response.data.message);
        }
      }
    }
  };

  const ReCaptchaComponent = () => {
    const { executeRecaptcha } = useGoogleReCaptcha()
    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        const token = await executeRecaptcha('yourAction');
        setValue('captcha', token)
    }, [executeRecaptcha]);
    return (
        <button style={imNotArobotButtonStyles} type="button" onClick={handleReCaptchaVerify}>
            <div style={{width: "30px", height: "30px", border: "2px solid #C1C1C1", borderRadius: "3px"}}>
                {watch("captcha") ? <CheckIcon color="success"/> : null}
            </div>
            I'm not a robot
            <img src="/images/recaptcha-icon.png" alt="" style={{width: "50px"}} />
        </button>
        // <Button variant="outlined" fullWidth endIcon={watch("captcha") ? <CheckIcon/> : null} onClick={handleReCaptchaVerify}>{t("views.signup.notRobot")}</Button>
    )
  }

  return (
    <>
      {signupSppiner && (
        <Box
          sx={{
            height: "100vh",
            width: "100vw",
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 10000,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <Circularbar />
        </Box>
      )}
      <AuthLayout>
          <Typography textAlign="center" maxWidth="460px" variant="h3" sx={{
              color: "#016AFE"
          }}>VCPlayer</Typography>
          <Typography textAlign="center" maxWidth="460px" variant="h4" sx={{
              color: "#313031"
          }}>SIGNAGE</Typography>
          <Button
            variant={"outlined"}
            sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px", width: "40px" }}
            onClick={onGoogleLogin}>
            <img src="/images/googleIcon.png" style={{ height: "100%", width: "100%", objectFit: "contain" }} />
          </Button>
          <form onSubmit={handleSubmit(onSubmit)} noValidate style={{width: '100%', maxWidth: "460px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              gap: "20px",
          }}>
              <TextField
                {...register("fullname", {
                  required: true,
                })}
                variant={"standard"}
                label={t("views.signup.fullName")}
                type={"text"}
                fullWidth
              />
              {errors.fullname && (
                <Typography sx={{ color: "warning.main" }}>{errors.fullname?.type == 'required' ? t("views.signup.nameRequired") : errors.fullname.message}</Typography>
              )}
              
              <TextField
                  {...register("email", {
                  required: true, pattern: {
                    value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: t("views.signup.invalidEmail")
                  }
                  })}
                  variant={"standard"}
                  label={t("views.login.email")}
                  type={"email"}
                  fullWidth
              />
              {errors.email && (
                <Typography sx={{ color: "warning.main" }}>{errors.email?.type == 'required' ? t("views.login.emailRequired") : errors.email.message}</Typography>
              )}
              
              <FormControl variant={"standard"} fullWidth>
                  <InputLabel htmlFor="password">{t("views.login.password")}</InputLabel>
                  <Input
                  id="password"
                  type={type ? "password" : "text"}
                  sx={{ background: "transparent", color: "#313031" }}
                  {...register("password", {
                      required: true,
                      minLength: 6,
                  })}
                  endAdornment={
                      <InputAdornment position={"end"} style={{ marginTop: "-10px", color: "#551fff" }}>
                      <IconButton aria-label="toggle password visibility" onClick={() => setType(!type)}>
                          {type ? <VisibilityOffIcon style={{ color: "#551fff" }} /> : <VisibilityIcon style={{ color: "#551fff" }} />}
                      </IconButton>
                      </InputAdornment>
                  }
                  />
              </FormControl>
              {errors.password && (
                <Typography sx={{ color: "warning.main" }}>{errors.password?.type == 'required' ? t("views.login.passwordRequired") : errors.password?.type == "minLength" ? t("views.login.passToShort") : errors.password.message}</Typography>
              )}

              <FormControl variant={"standard"} fullWidth>
                <InputLabel htmlFor="confirmPassword">{t("views.signup.confirmPassword")}</InputLabel>
                <Input
                  id="confirmPassword"
                  type={confirmPasswordType ? "password" : "text"}
                  sx={{ color: "#313031" }}
                  {...register("confirmPassword", {
                    required: true,
                    validate: (value) => value === getValues("password") || t("views.signup.passwordMismatch"),
                  })}
                  endAdornment={
                    <InputAdornment position={"end"} style={{ marginTop: "-10px", color: "#551fff" }}>
                      <IconButton aria-label="toggle password visibility" onClick={() => setConfirmPasswordType(!confirmPasswordType)}>
                        {confirmPasswordType ? <VisibilityOffIcon style={{ color: "#551fff" }} /> : <VisibilityIcon style={{ color: "#551fff" }} />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              {errors.confirmPassword && (
                <Typography color="warning.main">{errors.confirmPassword?.type == "required" ? t("views.login.passwordRequired") : errors.confirmPassword?.message}</Typography>
              )}

              <Box
                sx={{
                  height: "50px",
                  width: "100%",
                  margin: "5px auto",
                  display: "flex",
                  flexDirection: "column",
                }}>
                <Box
                  sx={{
                    alignItems: "center",
                    display: "flex",
                    ml: "-9px",
                    width: "100%",
                  }}>
                  <Controller
                    control={control}
                    name={"policy"}
                    defaultValue={false}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <>
                        <Checkbox {...field} />
                        <Typography color="text.secondary" variant="body1">
                          I have read the <a href="https://vcplayer.com/terms-and-conditions">Terms and Conditions</a>
                        </Typography>
                      </>
                    )}
                  />
                </Box>
                <Typography sx={{ color: "error.main" }}>{errors?.policy && "You need to accept Terms and Conditions"}</Typography>
              </Box>

              <Box
                sx={{
                  height: "50px",
                }}>
                <ReCaptchaComponent />
              </Box>

              <Box>
                  <Button variant="contained" type="submit" fullWidth sx={{
                      "&.Mui-disabled": {
                          background: "#d3d3d3ff",
                          color: "#919191ff"
                      }
                  }}>{t("views.signup.signUp")}</Button>
              </Box>

              <Box sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px"
              }}>
                  <Typography sx={{
                    color: "#313031"
                  }}>{t("views.signup.backToLogin")}</Typography>
                  <Link to={'/login'} style={{ textDecoration: "none", color: "#016AFE" }}>{t("views.signup.login")}</Link>
              </Box>
          </form>
      </AuthLayout>
    </>
  );
}

export default Signup;
